import React, { useState, memo, useRef } from 'react';
import { withGoogleMap, GoogleMap, DirectionsRenderer, Marker, InfoWindow } from 'react-google-maps';
import { messageError, messageSuccess, messageAlert } from '../components/toastr'
import { Button, Input, Modal, Typography } from 'antd';
import { SyncOutlined } from '@ant-design/icons'
import styles from './design.module.scss';

const MarkerList = memo(({ markers, selectedMarker, handleDraggableEnd, handleDraggableStart, handleClickMarker }) => (

    <>
        {!selectedMarker ? (
            markers.map((marker, index) => (
                <Marker
                    animation={selectedMarker && selectedMarker === marker ? window.google.maps.Animation.BOUNCE : null}
                    key={index}
                    position={{ lat: marker[1], lng: marker[0] }}
                    title={`Latitude: ${marker[1].toFixed(6)}, Longitude: ${marker[0].toFixed(6)}`}
                    draggable={true}
                    onDragStart={(e) => handleDraggableStart(e)}
                    onDragEnd={(e) => handleDraggableEnd(e)}
                    onClick={(e) => handleClickMarker(e)}
                    icon={{
                        url: 'https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png',
                        anchor: new window.google.maps.Point(0, 0),
                    }}

                />
            ))
        ) : (
            markers.map((marker, index) => {
                const isSelected = selectedMarker?.some(element => element === marker);
                return (
                    <Marker
                        animation={isSelected ? window.google.maps.Animation.BOUNCE : null}
                        key={index}
                        position={{ lat: marker[1], lng: marker[0] }}
                        title={`Latitude: ${marker[1].toFixed(6)}, Longitude: ${marker[0].toFixed(6)}`}
                        icon={{
                            url: 'https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png',
                            anchor: new window.google.maps.Point(0, 0),
                        }}
                    />
                )
            })
        )}
    </>
));


const MapComponent = withGoogleMap(({ defaultCenter, defaultZoom, onClick, onMapLoad, children, addNewPoint, onChangingZoom, onChangingCenter }) => (
    <GoogleMap
        center={defaultCenter}
        zoom={addNewPoint && defaultZoom < 14 ? 14 : defaultZoom}
        onClick={addNewPoint ? onClick : null}
        ref={onMapLoad}
        onZoomChanged={onChangingZoom}
        onCenterChanged={onChangingCenter}
        options={{

            draggableCursor: addNewPoint ? `url(https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png), auto` : ''
        }}

    >
        {children}
    </GoogleMap>
));


const Map = (props) => {
    const [allPoints, setAllPoints] = useState(props.instance.state.allPoints);
    const [center, setCenter] = useState({ lat: props.instance.state.latitude, lng: props.instance.state.longitude });
    const [zoom, setZoom] = useState(null);
    const [pointsToRelocate, setPointsToRelocate] = useState();
    const [openModal, setOpenModal] = useState(false);
    const [openInfoWindow, setOpenInfoWindow] = useState(false);
    const [selectedMarker, setSelectedMarker] = useState({});
    const [openEditCoords, setOpenEditCoords] = useState(false);
    const [latitudeEdit, setLatitudeEdit] = useState("");
    const [longitudeEdit, setLongitudeEdit] = useState("");
    const [openModalChangePosition, setOpenModalChangePosition] = useState(false);
    const [firstFocusInput, setFirstFocusInput] = useState(true);
    const [secondFocusInput, setSecondFocusInput] = useState(true);
    const { Text } = Typography;
    const mapRef = useRef(null);

    const getDirections = (directionsRef) => {
        props.instance.setState({
            directions: directionsRef.getDirections(),
        });
    };

    const handleMapClick = (event) => {
        const newMarker = {
            lat: event.latLng.lat(),
            lng: event.latLng.lng()
        };

        props.moveMap();
        updateRoute([newMarker.lng, newMarker.lat]);

    };

    const updateRoute = (newMarker) => {
        const { routeSelected } = props.instance.state;
        const copyAllPoints = allPoints;
        props.instance.serviceRoute.updateWayPoints({
            "routeId": routeSelected.routeId,
            "waypoints": [...allPoints, newMarker],
        }).then(response => {
            if (response.data.status !== 200) {
                messageError("ERRO! Falha no processamento desta ação, favor repetir o processo.");
            } else {
                messageSuccess("Ponto adicionado com sucesso!");
                const markerAdd = response.data.data[response.data.data.length - 1]
                mapRef.current.panTo({ lat: markerAdd[1], lng: markerAdd[0] });
                props.addUpdateToPoints(response.data.data);
                setAllPoints([...response.data.data]);
            }
        }).catch(errors => {
            if (errors && errors.status === 406) {
                setOpenModalChangePosition(true);
                setPointsToRelocate(errors.response.data.data);
                setAllPoints([...copyAllPoints]);
            } else {
                messageError("ERRO! Necessário que o ponto esteja a, no máximo, 50 metros de distância da rota. Aumento o zoom do mapa e tente novamente.");
                setCenter(mapRef.current.getCenter());
                setZoom(mapRef.current.getZoom());
            }


            if (errors && errors.response && errors.response.status === 401) {
                this.auth.endSession();
                props.history.push('/login');
            }
        });
    };

    const updatePositionMarker = (newMarker) => {
        const { routeSelected } = props.instance.state;

        const copyAllPoints = allPoints;
        const newPoints = allPoints.filter(point => !(point[0] === selectedMarker.lng && point[1] === selectedMarker.lat));
        setAllPoints(newPoints);
        props.instance.serviceRoute.updateWayPoints({
            "routeId": routeSelected.routeId,
            "waypoints": [...newPoints, newMarker],
        }).then(response => {
            if (response.data.status !== 200) {
                messageError("ERRO! Falha no processamento desta ação, favor repetir o processo.");
            } else {
                messageSuccess("Ponto atualizado com sucesso!");
                const markerAdd = response.data.data[response.data.data.length - 1]
                mapRef.current.panTo({ lat: markerAdd[1], lng: markerAdd[0] });
                props.addUpdateToPoints(response.data.data);
                setAllPoints([...response.data.data]);
                setOpenInfoWindow(false);
                setLatitudeEdit("");
                setLongitudeEdit("");
            }
        }).catch(errors => {
            if (errors && errors.status === 406) {
                setOpenModalChangePosition(true);
                setPointsToRelocate(errors.response.data.data);
                setAllPoints([...copyAllPoints]);

            } else {
                messageError("ERRO! Necessário que o ponto esteja a, no máximo, 50 metros de distância da rota. Aumento o zoom do mapa e tente novamente.");
                setCenter(mapRef.current.getCenter());
                setZoom(mapRef.current.getZoom());
            }

            if (errors && errors.response && errors.response.status === 401) {
                this.auth.endSession();
                props.history.push('/login');
            }

        });
    };

    const updateRelocatePositionMarker = () => {
        const { routeSelected } = props.instance.state;

        props.instance.serviceRoute.updateRelocateWayPoints({
            "routeId": routeSelected.routeId,
            "waypoints": pointsToRelocate,
        }).then(response => {
            if (response.data.status !== 200) {
                messageError("ERRO! Falha no processamento desta ação, favor repetir o processo.");
            } else {
                messageSuccess("Ponto atualizado com sucesso!");
                const markerAdd = response.data.data[response.data.data.length - 1]
                mapRef.current.panTo({ lat: markerAdd[1], lng: markerAdd[0] });
                props.addUpdateToPoints(response.data.data);
                setAllPoints([...response.data.data]);
                setOpenInfoWindow(false);
                setLatitudeEdit("");
                setLongitudeEdit("");
            }
        }).catch(errors => {
            setCenter(mapRef.current.getCenter());
            setZoom(mapRef.current.getZoom());

            if (errors && errors.response && errors.response.status === 401) {
                this.auth.endSession();
                props.history.push('/login');
            }

        });
    };

    const updateMarkers = (marker) => {

        const { routeSelected } = props.instance.state;
        const newPoints = allPoints.filter(point => !(point[0] === marker[0] && point[1] === marker[1]));

        setAllPoints(newPoints);
        props.instance.serviceRoute.updateWayPoints({
            "routeId": routeSelected.routeId,
            "waypoints": newPoints,
        }).then(response => {
            if (response.data.status !== 200) {
                messageError("ERRO! Falha no processamento desta ação, favor repetir o processo.");

            } else {
                messageSuccess("Ponto removido com sucesso!");
                props.addUpdateToPoints(response.data.data);
                //setAllPoints([...response.data.data]);
            }
        })
            .catch(errors => {
                messageError("ERRO! Necessário que o ponto esteja a, no máximo, 50 metros de distância da rota. Aumento o zoom do mapa e tente novamente.");
                setCenter(mapRef.current.getCenter());
                setZoom(mapRef.current.getZoom());

                if (errors && errors.response && errors.response.status === 401) {
                    this.auth.endSession();
                    props.history.push('/login');
                }
            });
    }
    const handleChangedZoom = () => {
        setZoom(mapRef.current.getZoom());
    }

    const handleChangedCenter = () => {
        setCenter(mapRef.current.getCenter());
    }

    const handleMapLoad = (mapInstance) => {
        mapRef.current = mapInstance;
    };

    const handleDraggableStart = (event) => {
        const startPositionMarker = {
            lng: event.latLng.lng(),
            lat: event.latLng.lat()

        };
        setSelectedMarker(startPositionMarker);
    }

    const handleDraggableEnd = (event) => {
        const endPositionMarker = {
            lng: event.latLng.lng(),
            lat: event.latLng.lat()

        };

        updatePositionMarker([endPositionMarker.lng, endPositionMarker.lat]);
    }

    const handleClickMarker = (event) => {
        const markerDelete = {
            lat: event.latLng.lat(),
            lng: event.latLng.lng()
        };

        setSelectedMarker(markerDelete);
        setOpenInfoWindow(true);

    }

    const handleConfirmDelete = () => {
        updateMarkers([selectedMarker.lng, selectedMarker.lat]);
        setOpenModal(false);
        setOpenInfoWindow(false);
        setOpenEditCoords(false);
    }

    const handleOpenModal = () => {
        setOpenModal(true);
    }
    const handleCancelDelete = () => {
        setOpenModal(false);
    }
    const handleCloseInfoWindow = () => {
        setOpenInfoWindow(false);
        setOpenEditCoords(false);
        setFirstFocusInput(true);
        setSecondFocusInput(true);
    }
    const handleChangeLatitude = (event) => {
        setLatitudeEdit(event.target.value);
    }
    const handleChangeLongitude = (event) => {
        setLongitudeEdit(event.target.value);
    }
    const handleUpdatePositionMarker = () => {
        if (latitudeEdit.includes(".") && longitudeEdit.includes("-") && longitudeEdit.includes("-")) {
            updatePositionMarker([longitudeEdit, latitudeEdit]);
            setFirstFocusInput(true);
            setSecondFocusInput(true);
        } else {
            messageAlert(`ATENÇÃO: A coordenada inserida deve estar em graus decimais!`);
            setFirstFocusInput(true);
            setSecondFocusInput(true);
        }
    }
    const handleCloseModalChangePosition = () => {
        setOpenModalChangePosition(false);
    }
    const handleConfirmChangePosition = () => {
        updateRelocatePositionMarker();
        setOpenModalChangePosition(false);

    }
    const handleFirstFocusInput = () => {
        setFirstFocusInput(false);
    }
    const handleSecondFocusInput = () => {
        setSecondFocusInput(false);
    }

    let directionsRef = null;

    return (
        <>
            {openEditCoords ?
                <div style={{ position: "absolute", backgroundColor: 'transparent', marginLeft: '30%', marginTop: '10px', zIndex: 1000, display: 'flex' }}>
                    <Input type='number' placeholder='Latitude' className={firstFocusInput ? styles.animation : styles.noAnimation} onChange={handleChangeLatitude} onClick={() => handleFirstFocusInput()} />
                    <Input type='number' placeholder='Longitude' className={secondFocusInput ? styles.animation : styles.noAnimation} onChange={handleChangeLongitude} onClick={() => handleSecondFocusInput()} />
                    <Button onClick={() => handleUpdatePositionMarker()} className={!firstFocusInput && !secondFocusInput ? styles.buttonAnimation : styles.buttonNoAnimation} icon={<SyncOutlined />}></Button>
                </div> :
                <></>}
            <MapComponent
                defaultCenter={center}
                defaultZoom={zoom}
                disableDefaultUI={true}
                onClick={handleMapClick}
                onMapLoad={handleMapLoad}
                onChangingZoom={handleChangedZoom}
                onChangingCenter={handleChangedCenter}
                containerElement={<div style={{ height: '450px', width: '100%', marginTop: '10px' }} />}
                mapElement={<div style={{ height: '100%' }} />}
                addNewPoint={props.addNewPoint}
            >

                <MarkerList markers={allPoints} selectedMarker={props.pointSelected} handleDraggableStart={handleDraggableStart} handleDraggableEnd={handleDraggableEnd} handleClickMarker={handleClickMarker} />
                <DirectionsRenderer
                    directions={props.instance.state.directions}
                    options={{ draggable: props.instance.state.draggable }}
                    onDirectionsChanged={() => getDirections(directionsRef)}
                />
                {openInfoWindow ?
                    <InfoWindow
                        position={selectedMarker}
                        onCloseClick={() => handleCloseInfoWindow()}

                    >
                        <div>
                            <h6>Coordenadas do ponto de parada:</h6>
                            <p><b>Lat: {selectedMarker.lat} Long: {selectedMarker.lng}</b></p>
                            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end' }}>
                                <Button
                                    size='small'
                                    style={{ marginRight: '10px', width: 65 }} onClick={() => handleCloseInfoWindow()} color='primary' variant="solid">
                                    Sair
                                </Button>
                                <Button size='small' style={{ marginRight: '10px', width: 65 }} color='danger' variant='solid' onClick={() => handleOpenModal()}>Excluir</Button>
                                <Button
                                    size='small'
                                    onClick={() => setOpenEditCoords(true)}
                                    style={{ width: 65, color: "white", backgroundColor: 'goldenrod', borderColor: 'goldenrod' }} variant="outlined">
                                    Editar
                                </Button>
                            </div>
                        </div>
                    </InfoWindow>
                    :
                    <>
                    </>
                }

            </MapComponent>
            <Modal open={openModal} title={"Deseja realmente excluir o ponto de parada com as coordenadas abaixo?"} cancelText={"Cancelar"} okText={"Confirmar"} onCancel={handleCancelDelete} onOk={handleConfirmDelete} width={"450px"}>
                LAT:{selectedMarker.lat} LONG:{selectedMarker.lng}
            </Modal>
            <Modal
                open={openModalChangePosition}
                cancelText={"Cancelar"}
                okText={"Confirmar"}
                onCancel={handleCloseModalChangePosition}
                onOk={() => handleConfirmChangePosition()}>
                {<Text>As coordenadas inseridas estão acima da tolerância requerida pela aplicação!
                    Deseja que tais coordenadas sejam ajustadas de acordo com a tolerância necessária?</Text>}
            </Modal>
        </>
    );

};

export default Map;